import React from 'react'

import { WithDataConnections } from 'data/wrappers/WithDataConnectionsComponent'

export const withDataConnections = (Child) => (props) => (
    <WithDataConnections>{(dcProps) => <Child {...dcProps} {...props} />}</WithDataConnections>
)
